import React from 'react';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import Paper from '../Paper';
import PaperTitle from '../PaperTitle';
import SGSubtitle from '../Typography/SGSubtitle';
import SGSwitch from '../CTA/SGSwitch';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import {useUserInfoState, userInfoActionTypes} from 'hooks/useUserInfo/UserInfoProvider';

const StyledPaper = styled(Paper)`
  code {
    width: 100%;
    word-wrap: break-word;
    display: inline-block;
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
  }
`;

function DebugView() {
  const {
    state: {isAdmin: admin, debugMode},
    dispatch: userInfoDispatch,
  } = useUserInfoState();

  const handleDebugToggle = () => {
    userInfoDispatch({
      type: userInfoActionTypes.TOGGLE_DEBUG_MODE,
    });
  };

  return admin ? (
    <StyledPaper>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <PaperTitle>Debug Setting</PaperTitle>
          <SGSubtitle className={'grey'}>ADMIN</SGSubtitle>
        </Grid>
        <Grid item xs={12}>
          <FormControl component="fieldset">
            <FormGroup aria-label="position" row>
              <FormControlLabel
                value="end"
                control={<SGSwitch onClick={() => handleDebugToggle()} checked={debugMode} />}
                label={`Debug View ${debugMode ? 'Enabled' : 'Disabled'}`}
                labelPlacement="end"
              />
            </FormGroup>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <SGSubtitle className={'grey'}>Environment</SGSubtitle>
          {process.env.REACT_APP_ENV}
        </Grid>
      </Grid>
    </StyledPaper>
  ) : null;
}

export default DebugView;
